import React, { useState, useEffect, useRef } from "react";
import {
  Navbar,
  Nav,
  NavDropdown,
  // Container,
  // Offcanvas,
  // Accordion,
} from "react-bootstrap";
import { NavLink } from "react-router-dom";
import Logo from "./logo-unik-system.png";
// import pdf1 from "./doc/Fiche_technique_Impression_HD_Pro.pdf";

const MainNavbar = () => {
  const [visible, setVisible] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [showMenu, setShowMenu] = useState(false);
  const lastScroll = useRef(0);

  useEffect(() => {
    const onScroll = () => {
      const current = window.scrollY;
      setVisible(current < 80 || current < lastScroll.current);
      lastScroll.current = current;
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <Navbar
        expand="lg"
        fixed="top"
        className={`main-navbar ${visible ? "show" : "hide"}`}
      >
        
          <Navbar.Brand as={NavLink} to="/" aria-label="UNIK SYSTEM">
            <img src={Logo} alt="LOGO UNIK SYSTEM" className="navbar-logo" />
          </Navbar.Brand>

          <Navbar.Toggle
            aria-controls="main-navbar-nav"
            onClick={() => setShowMenu(true)}
          />

          <Navbar.Collapse id="main-navbar-nav">
            <Nav className="main-nav ms-auto align-items-lg-center">
              <NavLink className="nav-link" to="/">
                Accueil
              </NavLink>

              {/* ===== SOLUTIONS DROPDOWN ===== */}
              <NavDropdown title="Solutions" id="solutions-dropdown">
              <NavDropdown title="Plafonds & Murs Tendus"><NavDropdown.Header as={NavLink} to="/plafond-tendu-maroc">Plafonds & Murs Tendus</NavDropdown.Header>
                <NavDropdown.Item as={NavLink} to="/plafond-mur-tendu-maroc">
                  US STRETCH
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/plafond-textile-maroc">
                  US TEXTILE
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/papier-peint-maroc">
                  US PRINT
                </NavDropdown.Item></NavDropdown>

                <NavDropdown.Divider />



                <NavDropdown title="Lighting"><NavDropdown.Header as={NavLink} to="/light-maroc">Lighting</NavDropdown.Header>
                <NavDropdown.Item as={NavLink} to="/plafond-lumineux-led-maroc">
                  US LIGHT rétroéclairage
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/eclairage-architectural-maroc">
                  US LIGHT architectural
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/eclairage-decoratif-maroc">
                  US LIGHT DÉCORATIF
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/lightbox-maroc">
                  US LIGHT BOX
                </NavDropdown.Item></NavDropdown>
                

                <NavDropdown.Divider />


                <NavDropdown title="Acoustique"><NavDropdown.Header as={NavLink} to="/acoustique-maroc">Acoustique</NavDropdown.Header>
                <NavDropdown.Item as={NavLink} to="/feutrine-acoustique-maroc">
                  US ACOUSTIC
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/acoustique-toile-maroc">
                  US ACOUSTIC AW
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/cabine-acoustique-maroc">
                  US ACOUSTIC CABINE
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/panneau-acoustique-maroc">
                  US LEVEL
                </NavDropdown.Item></NavDropdown>
                

                <NavDropdown.Divider />

                <NavDropdown title="Art Deco"><NavDropdown.Header as={NavLink} to="/art-deco-maroc">Art Deco</NavDropdown.Header>
                <NavDropdown.Item as={NavLink} to="/walldress-habillage-mural-maroc">
                  US WALLDRESS
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/artflow-decoration-murale-maroc">
                  US ARTFLOW
                </NavDropdown.Item>
                </NavDropdown>
                

                
                

                <NavDropdown.Divider />


                <NavDropdown title="Protection Solaire"><NavDropdown.Header as={NavLink} to="/protection-solaire-maroc">Protection Solaire</NavDropdown.Header>
                <NavDropdown.Item as={NavLink} to="/film-solaire-maroc">
                  US FILM solaire
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/film-decoratif-maroc">
                  US FILM décoratif
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/store-interieur-maroc">
                  US SOLAR Store
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/façade-bioclimatique-maroc">
                  US FACADE
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/store-banne-maroc">
                  US STORE BANNE
                </NavDropdown.Item>
</NavDropdown>
                
                <NavDropdown.Divider />



                <NavDropdown title="Architecture Textile"><NavDropdown.Header as={NavLink} to="/architecture-textile-maroc">ARCHITECTURE TEXTILE</NavDropdown.Header>
                <NavDropdown.Item as={NavLink} to="/structure-metallique-maroc">
                  US STRUCTURE
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/voile-dombrage-maroc">
                  US SHADE
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/parking-ombrage-abri-voiture-maroc">
                  US PARKING
                </NavDropdown.Item>
                </NavDropdown>
                </NavDropdown>
                
             

              

              <NavLink className="nav-link" to="/blog">
                Blog
              </NavLink>
              <NavLink className="nav-link" to="/services">
                Services
              </NavLink>
              <NavLink className="nav-link" to="/contact">
                Contact
              </NavLink>
              <NavLink className="nav-link btn-devis" to="/devis">
                Devis
              </NavLink>
            </Nav>
          </Navbar.Collapse>
        

        {/* ===== BARRE ROUGE AVEC MEGA MENU ===== */}
        <div className="solution-bar">

          {/* PLAFONDS */}
<div className="solution-item mega">
  <NavLink
    to="/plafond-tendu-maroc"
    className="solution-title"
  >
    <i className="fa-solid fa-layer-group"></i> Solution PLAFONDS & MURS TENDUS
  </NavLink>
            <div className="solution-mega">
              <NavLink to="/plafond-mur-tendu-maroc">US STRETCH</NavLink>
              <NavLink to="/plafond-textile-maroc">US TEXTILE</NavLink>
              <NavLink to="/papier-peint-maroc">US PRINT</NavLink>
            </div>
          </div>

           {/* LIGHTING */}
          <div className="solution-item mega">
            
                
                <NavLink className="solution-title" to="/light-maroc"><i className="fa-solid fa-lightbulb"></i> Solution LIGHTING</NavLink>
              
            
            <div className="solution-mega">
              <NavLink to="/plafond-lumineux-led-maroc">US LIGHT rétroéclairage</NavLink>
              <NavLink to="/eclairage-architectural-maroc">US LIGHT architectural</NavLink>
              <NavLink to="/eclairage-decoratif-maroc">US LIGHT DÉCORATIF</NavLink>
              <NavLink to="/lightbox-maroc">US LIGHT BOX</NavLink>
            </div>
          </div>

          {/* Solution Acoustique */}
<div className="solution-item mega">
  <NavLink
    to="/acoustique-maroc"
    className="solution-title"
  >
    <i className="fa-solid fa-volume-low"></i> Solution Acoustique
  </NavLink>
            <div className="solution-mega">
              <NavLink to="/feutrine-acoustique-maroc">US ACOUSTIC</NavLink>
              <NavLink to="/acoustique-toile-maroc">US ACOUSTIC AW</NavLink>
              <NavLink to="/cabine-acoustique-maroc">US ACOUSTIC CABINE</NavLink>
              <NavLink to="/panneau-acoustique-maroc">US LEVEL</NavLink>
            </div>
          </div>

          {/* Solution Arte */}
<div className="solution-item mega">
  <NavLink
    to="/art-deco-maroc"
    className="solution-title"
  >
    <i class="fas fa-paint-brush"></i> Solution Art Deco
  </NavLink>
            <div className="solution-mega">
              <NavLink to="/walldress-habillage-mural-maroc">US WALLDRESS</NavLink>
              <NavLink to="/artflow-decoration-murale-maroc">US ARTFLOW</NavLink>
            </div>
          </div>

         

          {/* SOLAIRE */}
          <div className="solution-item mega">
            
              
              <NavLink className="solution-title" to="/protection-solaire-maroc"><i className="fa-solid fa-sun"></i> Solution PROTECTION SOLAIRE</NavLink>
            
            <div className="solution-mega">

              <NavLink to="/film-solaire-maroc">US FILM solaire</NavLink>
              <NavLink to="/film-decoratif-maroc">US FILM décoratif</NavLink>
              <NavLink to="/store-interieur-maroc">US SOLAR Store</NavLink>
              <NavLink to="/façade-bioclimatique-maroc">US FACADE</NavLink>
              <NavLink to="/store-banne-maroc">US STORE BANNE</NavLink>
            </div>
          </div>

          {/* Architecture Textil */}
          <div className="solution-item mega">
            
              
              <NavLink className="solution-title" to="/architecture-textile-maroc"><i className="fa-solid fa-compass-drafting "></i>  Solution ARCHITECTURE TEXTILE</NavLink>
                          
            <div className="solution-mega">
              <NavLink to="/structure-metallique-maroc">US STRUCTURE</NavLink>
              <NavLink to="/voile-dombrage-maroc">US SHADE</NavLink>
              <NavLink to="/parking-ombrage-abri-voiture-maroc">US PARKING</NavLink>  
              
            </div>
          </div>

        </div>
      </Navbar>
      

      {/* ================= MOBILE OFFCANVAS ================= */}
      {/* <Offcanvas
        show={showMenu}
        onHide={() => setShowMenu(false)}
        placement="start"
        className="mobile-offcanvas"
      >
        <Offcanvas.Header closeButton>
          <img src={Logo} alt="UNIK SYSTEM" height="32" />
        </Offcanvas.Header>

        <Offcanvas.Body>
          <Nav className="mobile-nav">
            <NavLink to="/" onClick={() => setShowMenu(false)}>
              Accueil
            </NavLink>

            <Accordion flush>
              <Accordion.Item eventKey="0">
                <Accordion.Header>Solutions</Accordion.Header>
                <Accordion.Body>
                  <NavLink
                    to="/PlafondsMursTendus"
                    onClick={() => setShowMenu(false)}
                  >
                    Plafonds & Murs Tendus
                  </NavLink>
                  <NavLink
                    to="/SolutionAcoustique"
                    onClick={() => setShowMenu(false)}
                  >
                    Acoustique
                  </NavLink>
                  <NavLink
                    to="/SolutionLight"
                    onClick={() => setShowMenu(false)}
                  >
                    Lighting
                  </NavLink>
                  <NavLink
                    to="/ProtectionSolaire"
                    onClick={() => setShowMenu(false)}
                  >
                    Protection Solaire
                  </NavLink>
                  <NavLink
                    to="/ArchitectureTextil"
                    onClick={() => setShowMenu(false)}
                  >
                    Architecture Textile
                  </NavLink>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <NavLink to="/services" onClick={() => setShowMenu(false)}>
              Services
            </NavLink>
            <NavLink to="/contact" onClick={() => setShowMenu(false)}>
              Contact
            </NavLink>
            <NavLink
              to="/devis"
              className="btn-devis"
              onClick={() => setShowMenu(false)}
            >
              Devis
            </NavLink>
          </Nav>
        </Offcanvas.Body>
      </Offcanvas> */}
    </>
  );
};

export default MainNavbar;

// import React, { useState, useEffect, useRef } from "react";
// import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
// import { NavLink } from "react-router-dom";
// // import Logo from "./Logo.png";
// import Logo from "./logo-unik-system.jpg";
// import pdf1 from "./doc/Fiche_technique_Impression_HD_Pro.pdf";

// const MainNavbar = () => {
//   const [visible, setVisible] = useState(true);
//   const lastScroll = useRef(0);

//   useEffect(() => {
//     const onScroll = () => {
//       const current = window.scrollY;

//       if (current < 80) {
//         setVisible(true);
//       } else if (current > lastScroll.current) {
//         setVisible(false);
//       } else {
//         setVisible(true);
//       }

//       lastScroll.current = current;
//     };

//     window.addEventListener("scroll", onScroll);
//     return () => window.removeEventListener("scroll", onScroll);
//   }, []);

//   return (
//     <Navbar
//       expand="lg"
//       fixed="top"
//       className={`main-navbar ${visible ? "show" : "hide"}`}
//     >
//       <Container>
//         <Navbar.Brand as={NavLink} to="/" aria-label="UNIK SYSTEM">
//           <img src={Logo} alt="LOGO UNIK SYSTEM" className="navbar-logo" />
//         </Navbar.Brand>

//         <Navbar.Toggle aria-controls="main-navbar-nav" />
//         <Navbar.Collapse id="main-navbar-nav">
//           <Nav className="ms-auto align-items-lg-center">
//             <NavLink className="nav-link" to="/">
//               Accueil
//             </NavLink>
//             {/* SOLUTIONS */}
//             <NavDropdown title="Solutions" id="solutions-dropdown">
//               {/* Plafonds & Murs Tendus */}
//               <NavDropdown.Item
//                 as={NavLink}
//                   to="/PlafondsMursTendus"
//               >
//                 <i class="fa-solid fa-layer-group me-2"></i> Solutions Plafonds & Murs Tendus

//               </NavDropdown.Item>

//               <NavDropdown.Divider />

//               {/* Acoustique */}
//               <NavDropdown.Item
//                   as={NavLink}
//                   to="/SolutionAcoustique"
//                 >
//                   <i className="fa-solid fa-volume-low me-2"></i> Solutions Acoustique
//                 </NavDropdown.Item>

//               <NavDropdown.Divider />

//               {/* Lighting */}
//               <NavDropdown.Item as={NavLink} to="/SolutionLight">
//                   <i className="fa-solid fa-lightbulb me-2"></i> Solutions Lighting
//                 </NavDropdown.Item>

//               <NavDropdown.Divider />

//               {/* Protection Solaire */}
//               <NavDropdown.Item
//                   as={NavLink}
//                   to="/ProtectionSolaire"
//                 >
//                   <i class="fa-solid fa-shield me-2"></i> Solutions Protection Solaire
//                 </NavDropdown.Item>

//               <NavDropdown.Divider />

//               {/* Architecture Textile */}
//               <NavDropdown.Item
//                   as={NavLink}
//                   to="/ArchitectureTextil"
//                 >
//                   <i className="fa-solid fa-compass-drafting me-2"></i> Solutions Architecture Textile
//                 </NavDropdown.Item>
//             </NavDropdown>

//             <NavDropdown title="Documents" id="documents-dropdown">
//               {/* Plafonds & Murs Tendus */}
//               <NavDropdown
//                 title="Plafonds & Murs Tendus"
//                 id="plafonds-dropdown"
//                 drop="end"
//               >
//                 <NavDropdown.Item href={pdf1} download>
//                   <i class="fa-solid fa-file-arrow-down"></i> Plafond tendu
//                   laqué
//                 </NavDropdown.Item>
//                 <NavDropdown.Item href="/docs/plafond-mat-satin.pdf" download>
//                   <i class="fa-solid fa-file-arrow-down"></i> Plafond tendu mat
//                   / satin
//                 </NavDropdown.Item>
//                 <NavDropdown.Item href="/docs/mur-imprime.pdf" download>
//                   <i class="fa-solid fa-file-arrow-down"></i> Mur tendu imprimé
//                   HD
//                 </NavDropdown.Item>
//                 <NavDropdown.Item href="/docs/plafond-led.pdf" download>
//                   <i class="fa-solid fa-file-arrow-down"></i> Plafond
//                   rétroéclairé LED
//                 </NavDropdown.Item>
//                 <NavDropdown.Item href="/docs/plafond-acoustique.pdf" download>
//                   <i class="fa-solid fa-file-arrow-down"></i> Plafond acoustique
//                   tendu
//                 </NavDropdown.Item>
//               </NavDropdown>

//               <NavDropdown.Divider />

//               {/* Solutions Acoustiques */}
//               <NavDropdown
//                 title="Solutions Acoustiques"
//                 id="acoustique-dropdown"
//                 drop="end"
//               >
//                 <NavDropdown.Item href="/docs/panneaux-muraux.pdf" download>
//                   <i class="fa-solid fa-file-arrow-down"></i> Panneaux
//                   acoustiques muraux
//                 </NavDropdown.Item>
//                 <NavDropdown.Item href="/docs/plafond-acoustique.pdf" download>
//                   <i class="fa-solid fa-file-arrow-down"></i> Plafonds
//                   acoustiques tendus
//                 </NavDropdown.Item>
//                 <NavDropdown.Item href="/docs/baffles-acoustiques.pdf" download>
//                   <i class="fa-solid fa-file-arrow-down"></i> Baffles
//                   acoustiques suspendus
//                 </NavDropdown.Item>
//                 <NavDropdown.Item href="/docs/panneaux-decoratifs.pdf" download>
//                   <i class="fa-solid fa-file-arrow-down"></i> Panneaux
//                   décoratifs acoustiques
//                 </NavDropdown.Item>
//                 <NavDropdown.Item
//                   href="/docs/acoustique-sur-mesure.pdf"
//                   download
//                 >
//                   <i class="fa-solid fa-file-arrow-down"></i> Solutions
//                   acoustiques sur mesure
//                 </NavDropdown.Item>
//               </NavDropdown>

//               <NavDropdown.Divider />

//               {/* Solutions Lumineuses */}
//               <NavDropdown
//                 title="Solutions Lumineuses"
//                 id="lighting-dropdown"
//                 drop="end"
//               >
//                 <NavDropdown.Item href="/docs/plafond-lumineux.pdf" download>
//                   <i class="fa-solid fa-file-arrow-down"></i> Plafonds lumineux
//                   LED
//                 </NavDropdown.Item>
//                 <NavDropdown.Item href="/docs/lightbox.pdf" download>
//                   <i class="fa-solid fa-file-arrow-down"></i> Lightbox murale
//                 </NavDropdown.Item>
//                 <NavDropdown.Item href="/docs/eclairage-integre.pdf" download>
//                   <i class="fa-solid fa-file-arrow-down"></i> Éclairage
//                   architectural intégré
//                 </NavDropdown.Item>
//                 <NavDropdown.Item href="/docs/toile-translucide.pdf" download>
//                   <i class="fa-solid fa-file-arrow-down"></i> Toiles
//                   translucides lumineuses
//                 </NavDropdown.Item>
//                 <NavDropdown.Item
//                   href="/docs/eclairage-personnalise.pdf"
//                   download
//                 >
//                   <i class="fa-solid fa-file-arrow-down"></i> Éclairage
//                   décoratif personnalisé
//                 </NavDropdown.Item>
//               </NavDropdown>

//               <NavDropdown.Divider />

//               {/* Protection Solaire */}
//               <NavDropdown
//                 title="Protection Solaire"
//                 id="solar-dropdown"
//                 drop="end"
//               >
//                 <NavDropdown.Item href="/docs/stores-interieurs.pdf" download>
//                   <i class="fa-solid fa-file-arrow-down"></i> Stores intérieurs
//                 </NavDropdown.Item>
//                 <NavDropdown.Item href="/docs/stores-exterieurs.pdf" download>
//                   <i class="fa-solid fa-file-arrow-down"></i> Stores extérieurs
//                 </NavDropdown.Item>
//                 <NavDropdown.Item href="/docs/toiles-techniques.pdf" download>
//                   <i class="fa-solid fa-file-arrow-down"></i> Toiles techniques
//                   solaires
//                 </NavDropdown.Item>
//                 <NavDropdown.Item
//                   href="/docs/ombrage-architectural.pdf"
//                   download
//                 >
//                   <i class="fa-solid fa-file-arrow-down"></i> Ombrage
//                   architectural
//                 </NavDropdown.Item>
//                 <NavDropdown.Item href="/docs/protection-facades.pdf" download>
//                   <i class="fa-solid fa-file-arrow-down"></i> Protection solaire
//                   sur mesure
//                 </NavDropdown.Item>
//                 <NavDropdown.Item href="/docs/protection-facades.pdf" download>
//                   <i class="fa-solid fa-file-arrow-down"></i> Film solaire
//                 </NavDropdown.Item>
//               </NavDropdown>
//             </NavDropdown>
//             <NavLink className="nav-link" to="/services">
//               Services
//             </NavLink>
//             <NavLink className="nav-link" to="/contact">
//               Contact
//             </NavLink>
//             <NavLink className="nav-link btn-devis" to="/devis">
//               Devis
//             </NavLink>
//           </Nav>
//         </Navbar.Collapse>
//       </Container>
//     </Navbar>
//   );
// };

// export default MainNavbar;

// {/* SOLUTIONS */}
//             <NavDropdown title="Solutions" id="solutions-dropdown">
//               {/* Plafonds & Murs Tendus */}
//               <NavDropdown
//                 title="Solutions Plafonds & Murs Tendus"
//                 id="solutions-plafonds-dropdown"
//                 drop="end"
//                 to="/PlafondsMursTendus"
//               >
//                 <NavDropdown.Item
//                   as={NavLink}
//                   to="/PlafondsMursTendus"
//                 >
//                   <i class="fa-solid fa-border-all"></i> Solutions Plafonds & Murs Tendus

//                 </NavDropdown.Item>
//                 <NavDropdown.Item
//                   as={NavLink}
//                   to="/solutions/plafond-tendu-laque"
//                 >
//                   <i className="fa-solid fa-layer-group"></i> Plafond tendu
//                   laqué
//                 </NavDropdown.Item>

//                 <NavDropdown.Item
//                   as={NavLink}
//                   to="/solutions/plafond-tendu-mat"
//                 >
//                   <i className="fa-solid fa-layer-group"></i> Plafond tendu mat
//                   / satin
//                 </NavDropdown.Item>

//                 <NavDropdown.Item
//                   as={NavLink}
//                   to="/solutions/plafond-tendu-imprime"
//                 >
//                   <i className="fa-solid fa-image"></i> Plafond tendu imprimé HD
//                 </NavDropdown.Item>

//                 <NavDropdown.Item
//                   as={NavLink}
//                   to="/solutions/plafond-tendu-led"
//                 >
//                   <i className="fa-solid fa-lightbulb"></i> Plafond rétroéclairé
//                   LED
//                 </NavDropdown.Item>

//                 <NavDropdown.Item
//                   as={NavLink}
//                   to="/solutions/plafond-tendu-acoustique"
//                 >
//                   <i className="fa-solid fa-volume-low"></i> Plafond acoustique
//                   tendu
//                 </NavDropdown.Item>
//               </NavDropdown>

//               <NavDropdown.Divider />

//               {/* Acoustique */}
//               <NavDropdown
//                 title="Solutions Acoustique"
//                 id="solutions-acoustique-dropdown"
//                 drop="end"
//               >
//                 <NavDropdown.Item
//                   as={NavLink}
//                   to="/SolutionAcoustique"
//                 >
//                   <i className="fa-solid fa-volume-low"></i> Solutions Acoustique
//                 </NavDropdown.Item>
//                 <NavDropdown.Item
//                   as={NavLink}
//                   to="/solutions/panneaux-acoustiques"
//                 >
//                   <i className="fa-solid fa-layer-group"></i> Panneaux
//                   acoustiques
//                 </NavDropdown.Item>

//                 <NavDropdown.Item as={NavLink} to="/solutions/mur-acoustique">
//                   <i className="fa-solid fa-wave-square"></i> Mur acoustique
//                   décoratif
//                 </NavDropdown.Item>

//                 <NavDropdown.Item
//                   as={NavLink}
//                   to="/solutions/plafond-acoustique"
//                 >
//                   <i className="fa-solid fa-wave-square"></i> Plafond acoustique
//                 </NavDropdown.Item>

//                 <NavDropdown.Item
//                   as={NavLink}
//                   to="/solutions/acoustique-sur-mesure"
//                 >
//                   <i className="fa-solid fa-screwdriver-wrench"></i> Acoustique
//                   sur mesure
//                 </NavDropdown.Item>
//               </NavDropdown>

//               <NavDropdown.Divider />

//               {/* Lighting */}
//               <NavDropdown
//                 title="Solutions Lighting"
//                 id="solutions-lighting-dropdown"
//                 drop="end"
//               >
//                 <NavDropdown.Item as={NavLink} to="/SolutionLight">
//                   <i className="fa-solid fa-lightbulb"></i> Solutions Lighting
//                 </NavDropdown.Item>
//                 <NavDropdown.Item as={NavLink} to="/solutions/plafond-lumineux">
//                   <i className="fa-solid fa-layer-group"></i> Plafond lumineux LED
//                 </NavDropdown.Item>

//                 <NavDropdown.Item as={NavLink} to="/solutions/lightbox">
//                   <i className="fa-solid fa-square-full"></i> Lightbox murale
//                 </NavDropdown.Item>

//                 <NavDropdown.Item
//                   as={NavLink}
//                   to="/solutions/eclairage-integre"
//                 >
//                   <i className="fa-solid fa-bolt"></i> Éclairage architectural
//                   intégré
//                 </NavDropdown.Item>

//                 <NavDropdown.Item
//                   as={NavLink}
//                   to="/solutions/toile-translucide"
//                 >
//                   <i className="fa-solid fa-sun"></i> Toile translucide
//                   lumineuse
//                 </NavDropdown.Item>
//               </NavDropdown>

//               <NavDropdown.Divider />

//               {/* Protection Solaire */}
//               <NavDropdown
//                 title="Solutions Protection Solaire"
//                 id="solutions-solaire-dropdown"
//                 drop="end"
//               >
//                 <NavDropdown.Item
//                   as={NavLink}
//                   to="/ProtectionSolaire"
//                 >
//                   <i class="fa-solid fa-shield"></i> Solutions Protection Solaire
//                 </NavDropdown.Item>
//                 <NavDropdown.Item
//                   as={NavLink}
//                   to="/solutions/stores-interieurs"
//                 >
//                   <i class="fa-solid fa-store"></i> Stores intérieurs
//                 </NavDropdown.Item>

//                 <NavDropdown.Item
//                   as={NavLink}
//                   to="/solutions/stores-exterieurs"
//                 >
//                   <i class="fa-duotone fa-solid fa-store"></i> Stores extérieurs
//                 </NavDropdown.Item>

//                 <NavDropdown.Item as={NavLink} to="/solutions/film-solaire">
//                   <i className="fa-solid fa-film"></i> Films solaires
//                 </NavDropdown.Item>

//                 <NavDropdown.Item
//                   as={NavLink}
//                   to="/solutions/ombrage-architectural"
//                 >
//                   <i className="fa-solid fa-umbrella"></i> Ombrage architectural
//                 </NavDropdown.Item>
//               </NavDropdown>

//               <NavDropdown.Divider />

//               {/* Architecture Textile */}
//               <NavDropdown
//                 title="Solutions Architecture Textile"
//                 id="solutions-textile-dropdown"
//                 drop="end"
//               >
//                 <NavDropdown.Item
//                   as={NavLink}
//                   to="/ArchitectureTextil"
//                 >
//                   <i className="fa-solid fa-compass-drafting"></i> Solutions Architecture Textile
//                 </NavDropdown.Item>
//                 <NavDropdown.Item
//                   as={NavLink}
//                   to="/solutions/structures-textiles"
//                 >
//                   <i className="fa-solid fa-draw-polygon"></i> Structures
//                   textiles tendues
//                 </NavDropdown.Item>

//                 <NavDropdown.Item as={NavLink} to="/solutions/facades-textiles">
//                   <i className="fa-solid fa-building"></i> Façades textiles
//                 </NavDropdown.Item>

//                 <NavDropdown.Item
//                   as={NavLink}
//                   to="/solutions/couvertures-textiles"
//                 >
//                   <i className="fa-solid fa-tents"></i> Couvertures & auvents
//                 </NavDropdown.Item>
//               </NavDropdown>
//             </NavDropdown>
